import * as styles from "./css/Container.module.css";
const Container = props => {
    return <div class={styles.container}>{props.children}</div>;
};
export { Container };
